import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getMovingVehicleTypesRequest } from "lib/api/reference/movingVehicleType";
import type { MovingVehicleTypeInterface } from "types/reference";

export const movingVehicleTypeReferenceKeys = {
    all: ["reference", "moving-vehicle-type"] as const,
    list: (languageCode: string) => [...movingVehicleTypeReferenceKeys.all, "list", languageCode] as const,
};

export const fetchMovingVehicleTypes = (languageCode: string) =>
    parseResponse<Array<MovingVehicleTypeInterface>>(getMovingVehicleTypesRequest(languageCode));

export const movingVehicleTypeReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<MovingVehicleTypeInterface>>({
        queryKey: movingVehicleTypeReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchMovingVehicleTypes(languageCode),
        enabled: Boolean(languageCode),
    });

export const useMovingVehicleTypes = (languageCode: string) =>
    useQuery(movingVehicleTypeReferenceQueryOptions(languageCode));
